import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useParams } from 'react-router-dom';
import { PlanActions } from '../../../../../store/actions/plans';

import OrgBotTotalConsumption from './components/Reports/OrgBotTotalConsumption';
import OrgBotTotalConsumptionGraphic from './components/Graphics/OrgBotTotalConsumptionGraphic';
import Filter from './components/Filter';

const OrgConsumption = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());

  const { planConsumption } = useSelector(({ plans }) => plans);
  const user = useSelector((state) => state?.users?.signedUser);

  const dispatch = useDispatch();
  const params = useParams();

  const companyId = params?.orgId;
  const timezone =
    user && user?.selectedCompany
      ? user?.selectedCompany?.timezone.fuso
      : undefined;

  const reportFilter = {
    companyId,
    date: selectedDate,
    timezone,
    isReport: true,
  };

  useEffect(() => {
    dispatch(PlanActions.getPlanConsumption(reportFilter));
  }, []);

  const handleFilter = () => {
    dispatch(PlanActions.getPlanConsumption(reportFilter));
  };

  return (
    <>
      <Filter
        value={selectedDate}
        onChange={setSelectedDate}
        onSubmit={handleFilter}
      />
      <OrgBotTotalConsumption
        totalConsumption={planConsumption?.whatsappConsumption || 0}
      />
      <OrgBotTotalConsumptionGraphic
        data={planConsumption?.whatsappConsumptionByBot || []}
      />
    </>
  );
};

export default OrgConsumption;
